module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_pref",
    attrs: {
      "epub:type": "preface"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VII",
      "title": "VII"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig1",
      "src": "images/chap1.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev2"
  }, [_c('b', [_vm._v("We are delighted and honored ")])]), _vm._v("that InterVarsity Press asked us to develop a revised and expanded edition of our book "), _c('i', [_vm._v("Philosophy Made Slightly Less Difficult")]), _vm._v(". Since the publication of the first edition in 2005, we have received encouraging feedback about how useful the book has been at the college and seminary level. But just as or even more exciting has been how God has used the book to introduce a general audience to important concepts and distinctions in philosophy. We have both walked with the Lord for over fifty years, and during those decades, our hearts have been directed toward evangelism, discipleship, church planting, and the growth and maturation of the body of Christ. We have focused our energies on equipping, training, empowering, and emboldening believers toward these ends. And we have long recognized that developing a biblically based and philosophically informed Christian worldview is absolutely critical for the church, especially in our chaotic and secularized culture. Philosophy has always been of supreme help in developing a Christian worldview and teaching believers why they believe what they believe.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In addition to minor corrections, we have added material to several chapters and have included two new chapters: one on aesthetics, another on philosophy of religion. And we add our thanks to our editors at IVP, Dr. David McNutt and Ms. Rebecca Carhart. Thus, we offer this exciting updated and revised edition in the hopes that it will increase the impact for Christ that began with our first edition.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 63
// module chunks = 0